import { useDispatch, useSelector } from "react-redux";
import { setMainLoading, setPageTitle } from "../../Store/reducers/Common";
import { useEffect, useState } from "react";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import Pagination from "../../Services/Pagination";

const WhatsAppMessageList = () => {
    const dispatch = useDispatch();
    const { accessToken } = useSelector(state => state.user);
    const [statusFilter,setStatusFilter] = useState('all');
    const [showFilter, setShowFilter] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [messageList,setMessageList] = useState([]);
    const [paginationData, setPaginationData] = useState({ total: 0, per_page: 50 });
    useEffect(() => {
        dispatch(setPageTitle('WhatsApp Message List'));
    }, [dispatch]);
    const runFilter = (pageNo = 0) =>{
        dispatch(setMainLoading(true));
        let postData = {
            status : statusFilter
        };
        if (pageNo > 0) {
            postData.page = pageNo;
            postData.perPage = paginationData.per_page;
        }
        PostAxios(`whatsapp/message-list`, postData, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    setPaginationData({ total: data.totalRecords, per_page: data.perPage });
                    setMessageList(data.list);
                }
                else {
                    setPaginationData({ total: 0, per_page: 50 });
                    setMessageList([]);
                }
            })
            .catch((err) => {
                responseCatchFunc(dispatch, err)
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    return (
        <div className="main-form-sec">
            <div className="top-reports-filter">
                <div className={`right-filter-sec`}>
                    <button className="filter-toggle" onClick={() => {
                        setShowFilter(!showFilter);
                    }}>
                        <i className="fa-solid fa-filter"></i>
                    </button>
                    <div className={`p-0 filter-search form-field-group report-filter  ${(showFilter) ? '' : 'filter-active'}`}>
                            <div className="report-filter-field">
                                <label className="select-input-outer">Status</label>
                                <div className="static-items-outer">
                                    <select
                                        id="statusFilter"
                                        name="statusFilter"
                                        className="select-input"
                                        value={statusFilter}
                                        onChange={(e) => {
                                            setStatusFilter(e.target.value)
                                        }}
                                    >
                                        <option value='all'>All</option>
                                        <option value='pending'>Pending</option>
                                        <option value='sent'>Sent</option>
                                        <option value='failed'>Failed</option>
                                        
                                    </select>
                                </div>
                            </div>
                        <button type="button" className="btn btn-blue ms-2" onClick={() => { setCurrentPage(1); runFilter(1) }}>Submit</button>
                    </div>
                </div>
            </div>
            <div className="table-wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            <th>S.No.</th>
                            <th>Job Type</th>
                            <th>Type ID</th>
                            <th>WhatsApp Template</th>
                            <th>Phone</th>
                            <th>Status</th>
                            <th>Message Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            messageList.length > 0 && messageList.map((item, index) => {
                                return <tr key={`message-id-${index}-${item.id}`}>
                                    <td>{index + 1}</td>
                                    <td>{item.cron_job_type}</td>
                                    <td>{item.type_id}</td>
                                    <td>{item.whatsapp_template}</td>
                                    <td>{item.phone}</td>
                                    <td>{item.status}</td>
                                    <td>{item.message_status}</td>
                                </tr>
                            })
                        }
                    </tbody>
                </table>
            </div>
            <Pagination
                currentPage={currentPage}
                totalCount={paginationData.total}
                pageSize={paginationData.per_page}
                onPageChange={page => {
                    setCurrentPage(page);
                    runFilter(page);
                }}
            />
        </div>

    );
}

export default WhatsAppMessageList